<template>
  <modal :value="value"
         max-width="750"
         @input="emitInput">

    <div class="voucher-segment-client-modal-header">
      <app-search ref="searchBar" @enter="setClientListSearch" />

      <div class="voucher-segment-client-modal-header-actions">
        <i class="mdi mdi-file-upload-outline pointer"
           v-tooltip="'Adicionar arquivo'"
           @click="openFileUploadModal"></i>
        <i v-if="isVoucherType"
           class="mdi mdi-ticket-account pointer"
           v-tooltip="'Gerar vouchers'"
           @click="openGenerateVochersModal"></i>
        <i class="mdi mdi-plus-circle-outline pointer"
           v-tooltip="`Adição avulsa`"
           @click="openCreateDetachedModal"></i>
      </div>
    </div>

    <voucher-segment-client-list v-if="value"
                                 @reload="reloadList" 
                                 :search="search"
                                 :infinite-id="infiniteId"
                                 :segment="segment" 
                                 :page="page"
                                 @increment-page="page++"/>

    <voucher-segment-client-generate-modal v-model="showingGenerateModal"
                                           :segment="segment"
                                           @created="reloadList" />

    <voucher-segment-client-detached-create-modal v-model="showingCreateModal"
                                                  :segment="segment"
                                                  @created="reloadList" />

    <voucher-segment-client-file-modal v-model="showingUploadModal"
                                       :segment="segment"
                                       @created="reloadList" />
  </modal>
</template>

<script>
import VoucherSegmentClientFileModal from "@components/modules/voucher/segment/client/file/modal/VoucherSegmentClientFileModal.vue";
import VoucherSegmentClientGenerateModal from "@components/modules/voucher/segment/client/generate/modal/VoucherSegmentClientGenerateModal.vue";
import VoucherSegmentClientDetachedCreateModal from "@components/modules/voucher/segment/client/detached/create/modal/VoucherSegmentClientDetachedCreateModal.vue";
import AppSearch from "@components/Search";
import VoucherSegmentClientList from "@components/modules/voucher/segment/client/list/VoucherSegmentClientList.vue";
import Modal from "@/components/generic/Modal";

export default {
  components: {
    Modal,
    VoucherSegmentClientList,
    AppSearch,
    VoucherSegmentClientGenerateModal,
    VoucherSegmentClientDetachedCreateModal,
    VoucherSegmentClientFileModal,
  },

  data() {
    return {
      infiniteId: +new Date(),
      page: 0,
      showingGenerateModal: false,
      showingCreateModal: false,
      showingUploadModal: false,
      search: undefined,
    };
  },

  props: {
    value: {
      type: Boolean,
    },
    segment: {
      type: Object,
      required: true,
    },
  },

  watch: {
    value(showing) {
      if(showing) {
        this.page = 0;
        this.$refs.searchBar.setNullValue();
        this.search = undefined;
      }
    }
  },

  computed: {
    isVoucherType() {
      return this.segment.type === "VOUCHER_CODE";
    },
  },

  methods: {
    setClientListSearch(text) {
      this.page = 0;
      this.search = text;
    },
    emitInput(newVal) {
      if (newVal) {
        this.reloadList();
      }
      this.$emit("input", newVal);
    },
    reloadList() {
      this.page = 0
      this.infiniteId++;
    },
    openGenerateVochersModal() {
      this.showingGenerateModal = true;
    },
    openCreateDetachedModal() {
      this.showingCreateModal = true;
    },
    openFileUploadModal() {
      this.showingUploadModal = true;
    },
    
  },
};
</script>

<style lang="scss" scoped>
.voucher-segment-client-modal-header {
  display: flex;
  gap: 100px;

  .voucher-segment-client-modal-header-actions {
    display: flex;
    gap: 10px;
    i {
      font-size: 32px;
    }
  }
}
</style>
